import React from "react";
import { DropdownV2, InputV2 } from "../../../FormControlsV2";
import { DetachedTaskFiltersProps, MIN_DETACHED_TASK_DETAILS_LENGTH } from "./types";
import { useTranslation } from "react-i18next";

export function DetachedTaskFilters({
  farmOptions,
  currentFarm,
  onFarmChange,
  farmLabel,
  allResponsibles,
  currentResponsible,
  onResponsibleChange,
  taskDetails,
  onTaskDetailsChange,
}: DetachedTaskFiltersProps) {
  const { t } = useTranslation();
  const detailsLength = taskDetails?.length ?? 0;
  const detailsLabel =
    detailsLength < MIN_DETACHED_TASK_DETAILS_LENGTH
      ? `Detalhes da tarefa (${detailsLength}/${MIN_DETACHED_TASK_DETAILS_LENGTH} caracteres)`
      : "Detalhes da tarefa";

  return (
    <>
      <div className="filters-container filters-column">
        <div className="filters-dropdown filters-dropdown__full-width">
          <DropdownV2
            name="create-task-farm"
            label={t("taskCreation.farm")}
            placeholder={t("taskCreation.selectFarm")}
            options={farmOptions}
            value={currentFarm ?? null}
            menuMount="overlay"
            onChange={(opt) => onFarmChange(opt?.value)}
          />
        </div>
        <div className="filters-dropdown filters-dropdown__full-width">
          <DropdownV2
            name="create-task-responsible"
            label={t("taskCreation.responsible")}
            placeholder={t("taskCreation.selectResponsible")}
            options={allResponsibles}
            value={currentResponsible ?? null}
            menuMount="overlay"
            onChange={(opt) => onResponsibleChange(opt)}
          />
        </div>
      </div>
      <InputV2
        name="create-task-details"
        type="textarea"
        label={t("taskCreation.details", { min: MIN_DETACHED_TASK_DETAILS_LENGTH })}
        value={taskDetails}
        placeholder={t("taskCreation.describeTask")}
        onChange={(value) => onTaskDetailsChange(value)}
      />
    </>
  );
}
